export default "/kiban/_next/static/images/44_12L_3-6-3-ebdc5e590d453e93d9c9c1fea6dd51fc.png";